interface Props {
  total: number;
  limit: number;
  offset: number;
  onChange: (offset: number) => void;
  loading?: boolean;
  label?: string;
}

export function Pagination({
  total,
  limit,
  offset,
  onChange,
  loading,
  label,
}: Props) {
  const page = Math.floor(offset / limit) + 1;
  const pageCount = total === 0 ? 1 : Math.ceil(total / limit);
  const firstRow = total === 0 ? 0 : offset + 1;
  const lastRow = Math.min(total, offset + limit);

  return (
    <div className="pagination row-actions">
      <span className="meta">
        {label ? `${label}: ` : ""}
        {firstRow}–{lastRow} of {total} (page {page} of {pageCount})
      </span>
      <button
        type="button"
        className="luna-btn luna-btn-outline luna-btn-sm"
        onClick={() => onChange(Math.max(0, offset - limit))}
        disabled={loading || offset <= 0}
      >
        ← Prev
      </button>
      <button
        type="button"
        className="luna-btn luna-btn-outline luna-btn-sm"
        onClick={() => onChange(offset + limit)}
        disabled={loading || offset + limit >= total}
      >
        Next →
      </button>
    </div>
  );
}
